import { TaskBannerSize, TaskSelectBoxSize, TaskType } from '../types';

export const REQUIRED_DOCUMENT_TASKS = new Set<TaskType>([
  'document_conditionally_required',
  'document_type_required',
]);

export const REQUESTED_DOCUMENT_TASKS = new Set<TaskType>([
  'document_type_requested',
]);

export const THREAD_DOCUMENT_TASKS = new Set<TaskType>([
  'document',
]);

export const DOCUMENT_TASKS = new Set<TaskType>([
  ...REQUIRED_DOCUMENT_TASKS,
  ...REQUESTED_DOCUMENT_TASKS,
  ...THREAD_DOCUMENT_TASKS, 
]);

export const NON_MESSAGE_TASKS = new Set<TaskType>([
  'qc_mark_required',
  'sme_mark_required',
]);

export const TASK_TYPE_MAPPER_TEXT = new Map<TaskType, string>([
  ['qc_mark_required', 'QC Check Required'],
  ['sme_mark_required', 'SME Check Required'],
  ['document_conditionally_required', 'Conditional Document Required'],
  ['document_type_required', 'Document Required'],
  ['document_type_requested', 'Document Requested'],
  ['document', 'Document'],
  ['question', 'Question'],
  ['section', 'Section'],
]);

export const TASK_BANNER_SIZE_MAP: Record<TaskBannerSize, string> = {
  auto: 'auto',
  full: '100%',
  half: '50%',
};

export const TASK_SELECT_BOX_SIZE_MAP: Record<TaskSelectBoxSize, string> = {
  ...TASK_BANNER_SIZE_MAP,
  compact: '30rem',
  medium: '40rem',
  large: '55rem',
  'x-large': '70rem',
};
